import fpApiUtil from "./fp-api-util";

// MasterController POST /factoryplan/master/bom/flo (masterService.getFlo) — 인벤토리 1건을
// 기준으로 BOM/공정/BOR/자원/공구/부산물을 children 재귀 트리로 돌려준다.
const BASE = "factoryplan/master/bom";

const getFlo = (params) => fpApiUtil.postParams(`${BASE}/flo`, params);

const fpFloService = { getFlo };
export default fpFloService;
